export default {
    "Start a new project": "Démarrer un nouveau projet",
    "Open Project": "Ouvrir un projet",
    "Buy credits": "Acheter des crédits",
    "Buy Extra hours": "Acheter des heures supplémentaires",
    "Set a title and a date for your new project": "Définir un titre et une date pour votre nouveau projet",
    "Start": "Démarrer",
}